import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enGB from './locales/en-GB.json';

// i18n bootstrap. Single namespace at MVP; we split into per-panel namespaces
// once we have content to justify it. Locale set is en-GB only; the locale
// switcher and the six additional locales come in a later unit when we have
// enough content worth translating.
//
// All UI strings flow through useTranslation() — never inline literals — so
// adding a locale later is purely a translation effort, not a refactor.
await i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-GB',
    supportedLngs: ['en-GB'],
    defaultNS: 'common',
    ns: ['common'],
    resources: {
      'en-GB': { common: enGB },
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'hc.locale',
      caches: ['localStorage'],
    },
  });

export { i18n };
